import { formatShortDateAndHour, sortObjectWithDates } from '../../../utils/formatDatesAndHours';
import { IdateLog } from '../../../types/global';
import './NudosDatesLogs.scss';

const NudosDatesLogs = ({
  title,
  dates,
  sortOrder = 'desc'
}: {
  title?: string;
  dates: IdateLog[];
  sortOrder?: 'asc' | 'desc';
}) => {
  const sortedDates = sortObjectWithDates(dates, sortOrder || 'desc');

  return (
    <div className="nudosDatesLogs">
      {title && <div className="datesTitle">{title}</div>}
      <div className="datesContainer">
        {sortedDates.map((date, i) => {
          const isLast = i === 0;
          const dateStyles = date?.label === 'Cancelado' ? 'canceledDate' : isLast ? 'lastDate' : 'date';
          const key = `date-${date?.label}-${date?.date}`;
          const dateText = `${date?.label || ''}: ${formatShortDateAndHour(date?.date || '')?.textWithTimezone}`;
          return (
            <div key={key} className={dateStyles}>
              {dateText}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NudosDatesLogs;
